"use client";
import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import HomePageService from "@/services/api/HomeService";
import "swiper/css";
import SkeletonStudentReviewSection from "@/components/common/skeletons/SkeletonStudentReviewSection";
import dynamic from "next/dynamic";
import AntImage from "@/components/common/image/AntImage";
import { usePublicFetch } from "@/hook/usePublicFetch";
const Empty = dynamic(() => import("antd/es/empty"), { ssr: false });

export default function SuccessSliderSection({ successSliders }) {
  return (
    <>
      <section className="success_slider-section section_padding">
        <div className="container">
          <div className="section-content-wrap">
            {successSliders?.length > 0 ? (
              <div className="success-stories-slider">
                <div className="student-review">
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    slidesPerView={1}
                    spaceBetween={12}
                    autoplay={true}
                    speed={1500}
                    loop={true}
                    navigation={{
                      nextEl: ".success-next",
                      prevEl: ".success-prev",
                    }}
                    className="overflow-hidden"
                  >
                    {successSliders?.map((slider, idx) => (
                      <SwiperSlide key={idx}>
                        <div className="student-image-wrap">
                          <div className="student-review-img">
                            <AntImage
                              src={
                                slider?.desktop_image ??
                                "/images/home/success-slider.png"
                              }
                              alt={slider.name || "Image"}
                              className="student-img"
                              width={""}
                              height={""}
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className="student-arrow">
                  <div className="success-prev swiper-button-lock">
                    <button className="arrow-icon">
                      <FaChevronLeft />
                    </button>
                  </div>
                  <div className="success-next swiper-button-lock">
                    <button className="arrow-icon">
                      <FaChevronRight />
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <Empty description="কোনো রিভিউ নেই" />
            )}
          </div>
        </div>
      </section>
    </>
  );
}
